import { QueryClientProvider, QueryClient } from "@tanstack/react-query"
import { RouterProvider, createRouter } from "@tanstack/react-router"
import { bodyText, dxTheme } from "@ui"
import { initLogger, logError } from "@utils/errorLogging"

import "@ui/fonts.css"
import "./reset.css"

import React from "react"
import ReactDOM, { type RootOptions } from "react-dom/client"

import { routeTree } from "./routeTree.gen"

// analytics.init()

const errorLoggerUrl = import.meta.env.VITE_ERROR_LOGGER_URL
const errorLoggingEnabled =
  errorLoggerUrl !== undefined && errorLoggerUrl !== ""

if (errorLoggingEnabled) {
  initLogger({
    appName: import.meta.env.VITE_APP_NAME ?? "dovetail",
    appVersion: import.meta.env.VITE_APP_VERSION ?? "dev",
    baseUrl: errorLoggerUrl,
  })
}

const queryClient = new QueryClient()

const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  context: { queryClient },
})

declare module "@tanstack/react-router" {
  // oxlint-disable-next-line typescript/consistent-type-definitions -- Augmentation requires interface
  interface Register {
    router: typeof router
  }
}

document.documentElement.classList.add(dxTheme, bodyText)

const rootOptions: RootOptions | undefined = errorLoggingEnabled
  ? {
      onUncaughtError: (error, errorInfo) => logError(error, errorInfo),
      onCaughtError: (error, errorInfo) => logError(error, errorInfo),
    }
  : undefined

// oxlint-disable-next-line no-non-null-assertion
ReactDOM.createRoot(document.querySelector("#root")!, rootOptions).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      {/* <ModalRenderer />
      <Toaster /> */}
    </QueryClientProvider>
  </React.StrictMode>,
)
